Vendd.Scripts.load(function () {

    var currentLanguageCode = LhApp.Context.Language;

    var inlineEdit = function () {

    };

    inlineEdit.prototype.init = function () {

        Vendd.inlineEdit.uiLoader.init();

        var wrapper = $('body');

        Vendd.inlineEdit.uiLoader.show();

        Vendd.inlineEdit.languageManager.init(currentLanguageCode)
            .then(function() {

                var controls = Vendd.inlineEdit.controlFactory.Resolve(wrapper);

                return Q.all(controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.init(); }); }))
                    .then(function() { return Q.all(controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.build(); }); })); })
                    .then(function() { return Q.all(controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.render(); }); })); })
                    .then(function() { return Q.all(controls.map(function(x) { return Vendd.Promises.GetOrDefault(function() { return x.bind() }); })); })
                    .then(function() { Vendd.inlineEdit.uiLoader.hide(); })
                    .then(null, function(response) {
                        
                        var _error = response instanceof Error
                            ? response
                            : new ApiError("Unknown Error");

                        Vendd.logger.log(_error);
            
                        $('.js-inline-admin-edit-page-toolbar').hide();

                        throw new Error('Could not initialize controls');

                    });

            })
            .then(null, function () {

                Vendd.inlineEdit.uiLoader.hide();

                throw new Error('Could not initialize controls');

            })
            .done();

    };

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit = new inlineEdit();

});